import { render } from "./recordItem.vue?vue&type=template&id=45e0f55e&scoped=true"
import script from "./recordItem.vue?vue&type=script&lang=js"
export * from "./recordItem.vue?vue&type=script&lang=js"

import "./recordItem.vue?vue&type=style&index=0&id=45e0f55e&lang=less&scoped=true"

import exportComponent from "/Users/yiduolanghua/Desktop/edu/visitor-h5-jy/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45e0f55e"]])

export default __exports__